import React from 'react'
import { Empty, Table } from 'antd'
import moment from 'moment'

export default function GeneralReportContent({ report, loading }) {

	const columns = [
		{
			title: 'Nombre Asesor',
			dataIndex: 'agent_name',
			render: t => t ? t : <em>Sin registro</em>,
			filters: report.data.detail_table.map(r => ({ text: r.agent_name, value: r.agent_name })),
			filterMode: 'tree',
			filterSearch: true,
			onFilter: (value, record) => record.agent_name.startsWith(value),
		},
		{
			title: 'Cédula Asesor',
			dataIndex: 'agent_doc',
			filters: report.data.detail_table.map(r => ({ text: r.agent_doc, value: r.agent_doc })),
			filterMode: 'tree',
			filterSearch: true,
			onFilter: (value, record) => record.agent_doc.startsWith(value),
		},
		{
			title: 'Ventas Registradas',
			dataIndex: 'total_sales',
			render: t => `${t} ventas`
		},
		{
			title: 'Total Llamadas',
			dataIndex: 'total_calls',
			render: t => `${t} llamadas`
		},
		{
			title: 'Clics Btn WA',
			dataIndex: 'total_clicks',
			render: t => `${t} clics`
		},
	]

	const expandedRowRender = r => (
		<React.Fragment>
			<p className='mb-5'><b>Primer Registro: </b>{moment(r.first_sales_log).format('YYYY-MM-DD')}</p>
			<p className='mb-5'><b>Último Registro: </b>{moment(r.last_sales_log).format('YYYY-MM-DD')}</p>
		</React.Fragment>
	)

	return (
		<React.Fragment>
			<Table 
				dataSource={report.data.detail_table}
				columns={columns}
				rowKey={r => r.agent_doc}
				loading={loading}
				locale={{ emptyText: <Empty description="No se encontraron asesores con ventas" /> }}
				expandable={{ expandedRowRender }}
			/>
		</React.Fragment>
	)
}